import { v4 as uuidv4 } from 'uuid';

const DEFAULT_SFX_OBJECT = {

 "5-15 sec":[{
    "url": "https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3",
    "duration": 3,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'zoom',
    "section":0,

 },
{
    "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/db9eb2f7-60db-414a-ac31-5e0c0484e44c/audio.mp3",
    "duration": 0,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'Riser',
    "section":0

 },
 {
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1b1bb86e-bacd-481f-9b75-f7520d5a5916/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Beat Drop',
   "section":1
},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/596d4f0d-8c6f-4122-814c-99f4ce40f9b1/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Joyfull',
   "section":1
},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/845eedee-b2d7-4d33-be1e-00301e9e860d/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Point',
   "section":2
},

{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/845eedee-b2d7-4d33-be1e-00301e9e860d/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Point',
   "section":3
}


],
// -------------------------------------------------------------
"15-30 sec":[{
    "url": "https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3",
    "duration": 0,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'zoom',
    "section":0
 },
 {
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/db9eb2f7-60db-414a-ac31-5e0c0484e44c/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Riser',
   "section":0

},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1b1bb86e-bacd-481f-9b75-f7520d5a5916/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Beat Drop',
   "section":1
},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1b1bb86e-bacd-481f-9b75-f7520d5a5916/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Beat Drop',
   "section":1
},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/845eedee-b2d7-4d33-be1e-00301e9e860d/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Point',
   "section":2
},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/596d4f0d-8c6f-4122-814c-99f4ce40f9b1/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Joyfull',
   "section":3
},
{
   "url": "https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/845eedee-b2d7-4d33-be1e-00301e9e860d/audio.mp3",
   "duration": 0,
   "start": 0,
   "end": 0,
   "align": "left",
   "volume": 0.8,
   "name": 'Point',
   "section":4
}
],

// -------------------------------------------------------------

"30-60 sec":[{
    "url": "https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3",
    "duration": 0,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'zoom',
    "section":0
 }
],

// -------------------------------------------------------------


"60-90 sec":[{
    "url": "https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3",
    "duration": 0,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'zoom',
    "section":0
 }
],

// -------------------------------------------------------------


"90-120 sec":[{
    "url": "https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3",
    "duration": 0,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'zoom',
    "section":0
 }
],

// -------------------------------------------------------------


">120 sec":[{
    "url": "https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3",
    "duration": 0,
    "start": 0,
    "end": 0,
    "align": "left",
    "volume": 0.8,
    "name": 'zoom',
    "section":0
 }
]
}

export interface SFX {
  url: string;
  duration: number;
  start: number;
  end: number;
  align: string;
  volume: number;
  name: string;
  section: number;
}

interface Caption {
  words: {
    word: string;
    start: number;
    end: number;
  }[];
}

interface ScriptSection {
  captions: Caption[];
}

interface ScriptDetails {
  data: ScriptSection[];
}

interface Page {
  id: string;
  duration: number;
  custom: {
    scriptIndex: number;
  };
}

export const sfxAlign = (scriptDetails: ScriptDetails, duration: string, pages: Page[]): SFX[] => {
  if (!scriptDetails?.data || !duration || !pages) {
    return [];
  }

  // Get the default SFX configuration for the given duration
  const defaultSfx = DEFAULT_SFX_OBJECT[duration as keyof typeof DEFAULT_SFX_OBJECT];
  if (!defaultSfx) {
    return [];
  }

  // Create a copy of the default SFX array to avoid modifying the original
  const sfxCopy = JSON.parse(JSON.stringify(defaultSfx));

  // Keep track of cumulative duration for each section
  let cumulativeDuration = 0;

  // For each section in the script
  scriptDetails.data.forEach((section: ScriptSection, sectionIndex: number) => {
    // Get pages for this section
    const sectionPages = pages.filter(page => page.custom?.scriptIndex === sectionIndex);
    const sectionDuration = sectionPages.reduce((sum, page) => sum + page.duration, 0) / 1000; // Convert to seconds

    // Find all SFX items for this section
    const sectionSfx = sfxCopy.filter((sfx: SFX) => sfx.section === sectionIndex);

    if (sectionSfx.length > 0 && sectionDuration > 0) {
      sectionSfx.forEach((sfx: SFX, sfxIndex: number) => {
        switch (sfx.name.toLowerCase()) {
          case 'riser':
            // Place Riser at the end of the section
            sfx.duration = 1.5; // 1.5 seconds duration for riser
            sfx.start = cumulativeDuration + sectionDuration - sfx.duration; // Start from end minus duration
            sfx.end = cumulativeDuration + sectionDuration; // End at section end
            break;

          case 'beat drop':
            // Place Beat Drop at the start of the section
            sfx.start = cumulativeDuration;
            sfx.end = sfx.start + 3.0; // 1 second duration for beat drop
            sfx.duration = 3.0;
            break;

          case 'point':
            // Place Point in the middle of the section
            sfx.start = cumulativeDuration + (sectionDuration / 2) - 0.5;
            sfx.end = sfx.start + 1.0; // 1 second duration for point
            sfx.duration = 1.0;
            break;

          case 'joyfull':
            // Place Joyfull sound in the middle of the section
            sfx.start = cumulativeDuration + (sectionDuration / 2) - 0.75; // Center the 1.5s sound
            sfx.end = sfx.start + 3.0; // 1.5 seconds duration for joyfull
            sfx.duration = 3.0;
            break;

          case 'zoom':
            // Place Zoom at the start (zero)
            sfx.start = 0;
            sfx.end = sfx.start + 0.8; // 0.8 seconds duration for zoom
            sfx.duration = 0.8;
            break;

          default:
            // Default placement at the start of the section
            sfx.start = cumulativeDuration;
            sfx.end = sfx.start + 1.0;
            sfx.duration = 1.0;
        }

        // Ensure SFX doesn't exceed section boundaries
        sfx.start = Math.max(cumulativeDuration, Math.min(cumulativeDuration + sectionDuration - sfx.duration, sfx.start));
        sfx.end = Math.min(cumulativeDuration + sectionDuration, sfx.start + sfx.duration);
      });
    }

    // Add this section's duration to the cumulative total
    cumulativeDuration += sectionDuration;
  });

  // Add a unique id to each SFX
  const sfxWithIds = sfxCopy.map((sfx: SFX) => ({ ...sfx, id: uuidv4() }));

  console.log('Aligned SFX:', {
    totalDuration: cumulativeDuration,
    sfx: sfxWithIds
  });
  
  return sfxWithIds;
};